'use client';

import { c as _c } from "react/compiler-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';
import { ModalProvider } from './contexts/ModalContext';
import { BackgroundCacheProvider } from './contexts/BackgroundCacheContext';
interface ProvidersProps {
  children: React.ReactNode;
  withBackgroundCache?: boolean;
  withModal?: boolean;
}
export function Providers(t0) {
  const $ = _c(7);
  const {
    children,
    withBackgroundCache: t1,
    withModal: t2
  } = t0;
  const withBackgroundCache = t1 === undefined ? false : t1;
  const withModal = t2 === undefined ? false : t2;
  const [queryClient] = useState(_temp);
  let content = children;
  if (withModal) {
    let t3;
    if ($[0] !== content) {
      t3 = <ModalProvider>{content}</ModalProvider>;
      $[0] = content;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    content = t3;
  }
  if (withBackgroundCache) {
    let t3;
    if ($[2] !== content) {
      t3 = <BackgroundCacheProvider>{content}</BackgroundCacheProvider>;
      $[2] = content;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    content = t3;
  }
  let t3;
  if ($[4] !== content || $[5] !== queryClient) {
    t3 = <QueryClientProvider client={queryClient}>{content}</QueryClientProvider>;
    $[4] = content;
    $[5] = queryClient;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60000,
        refetchOnWindowFocus: false,
        retry: 1
      }
    }
  });
}